(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
  const data = window.SLDEstimatorData;
  const product = data.products.roundBottomSack;
  const controls = data.productControls.roundBottomSack;
  const sack = data.productControls.stakeSack;
  const closure = data.shared.components.sackClosure;
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const prompt = 'Select all sack options to see the estimated weight.';
  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const label=Object.keys(product.FIELD_LABELS).find(key=>key.replace(/\s+/g,' ').trim()===String(element.labels&&element.labels[0]&&element.labels[0].textContent||'').replace(/\s+/g,' ').trim());
      if (!own(product.FIELD_LABELS, label)) continue;
      const field = product.FIELD_LABELS[label];
      selected[field] = own(selected, field) ? null : element.value;
    }
    for (const field of Object.values(product.FIELD_LABELS)) if (!own(selected, field)) selected[field] = null;
    return selected;
  }
  function estimate(choice) {
    for (const [field, map] of [['Fabric','FABRICS'],['Width','WIDTHS'],['Length','LENGTHS'],['Daisy','DAISY'],['Handle','HANDLE'],['Bottom','BOTTOM']]) {
      if (typeof choice[field] !== 'string' || !own(product[map],choice[field])) return null;
    }
    const diameter = product.WIDTHS[choice.Width], length = product.LENGTHS[choice.Length];
    if (diameter < controls.minDiameter || diameter > controls.maxDiameter || length < controls.minLength || length > controls.maxLength) return null;
    const rawWidth = Math.ceil((Math.PI * diameter + controls.rawWidthExtra) / controls.rawWidthStep) * controls.rawWidthStep;
    const rawLength = length + controls.rawLengthExtra + controls.rawLengthDiameterFactor * diameter;
    const bottomDiameter = diameter + (diameter <= controls.smallCircleMaxDiameter ? controls.smallCircleExtra : controls.largeCircleExtra);
    const diskArea = Math.PI * bottomDiameter ** 2 / 4;
    const body = (rawWidth * rawLength + diskArea) / 1296 * product.FABRICS[choice.Fabric].planningDensity;
    const drawstring = (rawWidth + sack.drawstringExtra) * closure.catchAllDrawstringPerInch * sack.drawstringCount;
    const small = diameter <= controls.smallHardwareMaxDiameter;
    const lock = (small ? closure.mediumCordLock : closure.largeCordLock) * sack.cordLockCount;
    const webbingRate = small ? data.productControls.poleSack.webbing.fiveEighthPerInch : controls.webbing.threeQuarterPerInch;
    const webbingLength = product.DAISY[choice.Daisy] ? Math.max(controls.daisy.minimum,controls.daisy.step * Math.floor((length - controls.daisy.lengthDeduction) / controls.daisy.step)) : 0;
    const daisyTacks = product.DAISY[choice.Daisy] ? webbingLength / controls.daisy.step + controls.daisy.endTackExtra : 0;
    const webbing = webbingLength * webbingRate;
    const handle = product.HANDLE[choice.Handle] ? bottomDiameter * webbingRate : 0;
    const reinforcement = product.BOTTOM[choice.Bottom] ? (diskArea / sack.reinforcement.width + rawWidth - sack.reinforcement.lengthDeduction) * sack.reinforcement.weightPerInch : 0;
    const thread = controls.thread.base + daisyTacks * controls.thread.perDaisyTack + (product.HANDLE[choice.Handle] && !small ? controls.thread.largeHandlePair : 0);
    const finished = body + drawstring + lock + webbing + handle + reinforcement + thread;
    return {rawWidth,rawLength,bottomDiameter,body,drawstring,lock,webbingLength,webbing,handle,reinforcement,daisyTacks,thread,finished,grams:finished * sack.gramsPerOunce};
  }
  function format(result) {
    return result.finished.toFixed(sack.displayOunceDecimals) + ' oz / ' + Math.round(result.grams) + ' g';
  }
  function start() {
    const root = document.querySelector('[data-sld-round-bottom-sack-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;
    const results = root.querySelector('[data-sld-estimator-results]');
    const message = root.querySelector('[data-sld-estimator-message]');
    const weight = root.querySelector('[data-sld-weight-round-bottom-sack]');
    function text(element,value) { if (element && element.textContent !== value) element.textContent = value; }
    function calculate() {
      const result = estimate(selections(scope));
      if (results) results.hidden = !result;
      text(message,result ? '' : prompt);
      text(weight,result ? format(result) : '');
    }
    let timer;
    const queue = () => { clearTimeout(timer); timer = setTimeout(calculate,75); };
    scope.addEventListener('change',queue,true);
    scope.addEventListener('input',queue,true);
    new MutationObserver(mutations => {
      if (mutations.some(mutation => !root.contains(mutation.target))) queue();
    }).observe(scope,{subtree:true,childList:true,attributes:true,attributeFilter:['value','checked','selected']});
    calculate();
  }
  return {estimate,selections,format,start};
});
